module.exports = __webpack_public_path__ + "img/think-sky.49fc8224.png";